module.exports = __webpack_public_path__ + "img/face-swap-source.6f0e0103.webp";